import React, { useState } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { useWindowSize } from 'react-use'
import { Input, Typography, Button } from 'components'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;

  @media (max-width: 425px) {
    margin-bottom: 15px;
  }
`
const InputRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 15px;

  @media (max-width: 352px) {
    gap: 10px;
  }
`
const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
const CancelButton = styled((props) => <Typography {...props} />)`
  width: 100px;
  color: white;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  text-align: center;

  :hover {
    text-decoration: underline;
    color: ${(props) => props.theme['sa-blue']};
  }

  @media (max-width: 425px) {
    width: 80px;
    font-size: 12px;
  }
`

const CodeInput = (props) => {
  // console.log('props', props)
  const { locale, onClose, courseId, totalPrice, checkPromoCode, setAppliedCode } = props
  const isTh = locale === 'th'
  const { width } = useWindowSize()
  const [promoCode, setPromoCode] = useState('')
  const [isError, setIsError] = useState(false)
  const [appliedText, setAppliedText] = useState('')

  const onChange = (event) => {
    const code = (event.target.value || '').toUpperCase().trim()
    setPromoCode(code)
    setAppliedCode('')
    setAppliedText('')
    setIsError(false)
  }

  const onApply = async () => {
    try {
      if (promoCode) {
        await checkPromoCode({ courseId, promoCode, price: totalPrice })
        setIsError(false)
        setAppliedCode(promoCode)
        setAppliedText(
          isTh
            ? 'คูปองนี้ใช้ได้ : กรุณากดปุ่มลงทะเบียนด้านบนเพื่อเริ่มเรียน'
            : 'Code is valid : Please click enroll button'
        )
      } else {
        throw new Error('INVALID')
      }
    } catch (e) {
      setIsError(true)
      setAppliedCode('')
      setAppliedText(isTh ? 'เกิดข้อผิดพลาด : คูปองไม่ถูกต้อง' : 'Error : Code is invalid')
    }
  }

  return (
    <Container>
      <InputRow>
        <Input
          value={promoCode}
          onChange={onChange}
          full
          placeholder={isTh ? 'กรอกคูปองส่วนลด...' : 'Please input code...'}
          styleInput={{
            color: 'white',
            fontSize: width <= 425 ? 12 : 16,
            backgroundColor: 'black',
            opacity: 'unset',
            padding: '0 10px',
            border: '1px solid #FFFFFF',
            borderRadius: width <= 425 ? 8 : 10,
            height: width <= 425 ? 37 : 60,
          }}
        />
        <ButtonGroup>
          <Button
            id="course.detail.apply"
            secondary
            nowrap
            width={width <= 425 ? 80 : 100}
            height={width <= 425 ? 37 : 45}
            fontStyle={{ fontSize: width <= 425 ? 14 : 16 }}
            onClick={onApply}
          >
            Apply
          </Button>
          <CancelButton id="button.cancel" onClick={onClose}>
            Cancel
          </CancelButton>
        </ButtonGroup>
      </InputRow>
      {appliedText && (
        <Typography color={isError ? 'danger' : 'success'} style={{ textAlign: 'right' }}>
          {appliedText}
        </Typography>
      )}
    </Container>
  )
}

const mapDispatch = (dispatch) => {
  return {
    checkPromoCode: dispatch.Enrollment.checkPromoCode,
  }
}

export default connect(null, mapDispatch)(CodeInput)
